import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { DailyRestBlock } from '../blocks/DailyRestBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const DailyRestsLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { dailyRests } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {dailyRests.map((item, index) => (
        <DailyRestBlock key={index} dailyRest={item} index={index} />
      ))}
    </LayerWrapper>
  )
}

export default DailyRestsLayer
